<ng-container [ngSwitch]="errorState">
    <ng-container *ngSwitchCase="invalidLogin">
        <div class="flex flex-col px-8 py-6 rounded-gt-md-3 w-185 h-auto error-container mb-11">
            <div class="text-7gpx text-text-default-1 mb-2 font-body">
                Username and password is required.
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="disabled">
        <div class="mb-4">
            <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                    Sorry... Are you sure?
                </div>
                <div class="opacity-90 text-7gpx text-text-default font-body">
                    Because we couldn't find the requested account. Please contact HR for help.
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="loginErrorState.ACCOUNT_DISABLED">
        <div class="mb-4">
            <div class="flex flex-row p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="gt-icon gt-icon-times-circle mt-0.1 p-0.3"></div>
                <div class="flex flex-col pl-1">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Sorry! Looks like your account is disabled
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body">
                        But we want you back <span class="font-emoji text-9gpx" [innerHTML]="emoji"></span> Please contact your HR for help.
                    </div>
                </div> 
            </div>
        </div> 
    </ng-container>
    <ng-container *ngSwitchCase="loginErrorState.PASSWORD_EXPIRED">
        <div class="mb-4">
            <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="opacity-90 text-7gpx text-text-default font-body">
                    Oh, no! Please reset your password right now to keep your account secure.
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="loginErrorState.DISALLOWED_IPADDRESS">
        <div class="mb-4">
            <div class="flex flex-row p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="gt-icon gt-icon-times-circle mt-0.1 p-0.3"></div>
                <div class="flex flex-col pl-1">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Sorry! Login failed
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body">
                        Looks like you're trying to log in from a different location or device. Please try again.
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="loginErrorState.DISALLOWED_EMPLOYEE_LOGIN">
        <div class="mb-4">
            <div class="flex flex-row p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="gt-icon gt-icon-times-circle mt-0.1 p-0.3"></div>
                <div class="flex flex-col pl-1">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Sorry! Account locked.
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body">
                        Please connect with your site administrator. 
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="loginErrorState.INTERNAL_SERVER_ERROR">
        <div class="mb-4">
            <div class="flex flex-row p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                <div class="gt-icon gt-icon-times-circle mt-0.1"></div>
                <div class="flex flex-col pl-1">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Sorry! Well, it's not you. It's us.
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body">
                        An internal error occurred, but we are fixing it soon.
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="loginErrorState.OTP_FAILURE">
        <div class="mb-4">
            <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-50 bg-std-info">
                <div class="text-7gpx text-text-default-1 mb-2 font-body-semibold font-semibold">
                    Whoops!
                </div>
                <div class="opacity-90 text-7gpx text-text-default font-body">
                    Sorry, we could not start OTP verification. <br>
                    Please contact your HR for help.
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
